import { MobileApplicationAppConfig } from '../../types';

export const mobileApplicationAppConfig: MobileApplicationAppConfig = {
  androidApkUrl: 'https://storage.googleapis.com/static-content-lvbetcom-new/bcf-twa/lvbetlv/lvbetlv-sports.apk',
  iosStoreUrl: 'https://apps.apple.com/lv/app/lv-sports/id6448981044'
};
